import { SHARE_WITH_FRIEND_REQUEST } from '../types';

export const shareWithFriend = (email, bookingId) => ({ type: SHARE_WITH_FRIEND_REQUEST, payload: { email, bookingId } });
